"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.SEARCH_WIDGET_V2_THEME_KEYS = exports.SEARCH_WIDGET_V2_FALLBACKS = void 0;
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
const SEARCH_WIDGET_V2_FALLBACKS = exports.SEARCH_WIDGET_V2_FALLBACKS = {
  // <Prefix>_<Property>_<Element>
  sw_border_radius: 'border_radius',
  sw_border_radius_button: 'border_radius',
  sw_border_radius_chip: 'border_radius_chip',
  sw_border_radius_container: 'border_radius',
  sw_container_padding_h: 'spacing_xlarge',
  sw_container_padding_v: 'spacing_xlarge',
  sw_color_bg_container: 'color_background',
  sw_color_border: 'sw_color_bg_container',
  sw_color_button: 'color_button',
  sw_color_button_active: 'color_text',
  sw_color_button_disabled: 'color_button_disabled',
  sw_color_button_hover: 'color_button_hover',
  sw_color_button_hover_text: 'color_text_contrast',
  sw_color_button_text: 'color_text_contrast',
  sw_color_chip: 'color_button_secondary',
  sw_color_chip_hover: 'sw_color_button_hover',
  sw_color_chip_hover_text: 'sw_color_button_hover_text',
  sw_color_chip_text: 'color_text_secondary',
  sw_color_border_input_error: 'color_danger',
  sw_color_background_input_error: 'color_background_danger',
  sw_color_label: 'color_text',
  sw_color_label_search: 'sw_color_label',
  sw_color_label_location: 'sw_color_label',
  sw_font_face_label: 'font_face',
  sw_font_face_label_search: 'sw_font_face_label',
  sw_font_face_label_location: 'sw_font_face_label',
  sw_font_weight_label: 'font_weight',
  sw_font_weight_label_search: 'sw_font_weight_label',
  sw_font_weight_label_location: 'sw_font_weight_label',
  sw_font_face_label_error: 'sw_font_face_label',
  sw_font_weight_label_error: 'font_weight',
  sw_color_label_error: 'sw_color_label',
  sw_font_size_label_error: 'font_size_large',
  sw_font_size_label: 'font_size_large',
  sw_font_size_label_search: 'sw_font_size_label',
  sw_font_size_label_location: 'sw_font_size_label',
  sw_color_text: 'color_text',
  sw_color_input: 'sw_color_text',
  sw_color_input_search: 'sw_color_input',
  sw_color_input_location: 'sw_color_input',
  sw_color_border_input: 'color_border',
  sw_color_border_input_search: 'sw_color_border_input',
  sw_color_border_input_location: 'sw_color_border_input',
  sw_font_face_input: 'font_face',
  sw_font_face_input_search: 'sw_font_face_input',
  sw_font_face_input_location: 'sw_font_face_input',
  sw_font_size_input: 'font_size_large',
  sw_font_size_input_search: 'sw_font_size_input',
  sw_font_size_input_location: 'sw_font_size_input',
  sw_font_weight_input: 'font_weight',
  sw_font_weight_input_search: 'sw_font_weight_input',
  sw_font_weight_input_location: 'sw_font_weight_input',
  sw_color_outline_input: 'sw_color_button',
  sw_color_outline_input_search: 'sw_color_outline_input',
  sw_color_outline_input_location: 'sw_color_outline_input',
  sw_color_text_placeholder: 'color_text_placeholder',
  sw_color_text_placeholder_search: 'sw_color_text_placeholder',
  sw_color_text_placeholder_location: 'sw_color_text_placeholder',
  sw_color_border_suggest: 'color_border',
  sw_color_suggest_color: 'color_background',
  sw_color_suggest_item_hover: 'color_button_secondary',
  sw_color_suggest_item_key: 'color_text_secondary',
  sw_color_suggest_item_value: 'color_text',
  sw_color_suggest_item_focus_border: 'color_text',
  sw_font_face: 'font_face',
  sw_font_face_button: 'font_face',
  sw_font_size: 'font_size_large',
  sw_font_size_button: 'font_size_large',
  sw_font_weight_bold: 'font_weight_bolder',
  sw_font_weight_button: 'font_weight',
  sw_font_weight_suggest_item_key: 'font_weight',
  sw_font_weight_suggest_item_value: 'font_weight',
  sw_ext_link_text_color: 'sw_color_label',
  sw_ext_link_color: 'color_link',
  sw_ext_link_font_face: 'font_face',
  sw_ext_link_font_size: 'font_size_large',
  sw_spacing_xsmall: 'spacing_xsmall',
  sw_spacing_small: 'spacing_small',
  sw_spacing_medium: 'spacing_medium',
  sw_spacing_large: 'spacing_large',
  sw_spacing_xlarge: 'spacing_xlarge'
};
const SEARCH_WIDGET_V2_THEME_KEYS = exports.SEARCH_WIDGET_V2_THEME_KEYS = (0, _keys.default)(SEARCH_WIDGET_V2_FALLBACKS);